import { ApiCall } from "components/common/services/ApiServices";

export const isApiAccessDeniedError = (error: any): boolean => {
  const status = error?.status || error?.response?.status;
  const message = error?.message || error?.response?.data?.message || '';
  return status === 403 || message.toLowerCase().includes('forbidden') || message.toLowerCase().includes('access denied');
};

export const callLogApi = async (microservice: string, auth: any, payload: object) => {
  const fullPayload = {
    ...payload,
    userId: auth.userId,
    userRole: auth.role,
    appLangKey: "en-source",
    userTimeZone: "Asia/Calcutta"
  };
  const response = await ApiCall.service("fetch-logs", "POST", fullPayload, false, microservice);
  if (response?.status === 200 && response.data) {
    return response.data;
  }
  throw new Error(response?.message || "API request failed");
};